import { render, staticRenderFns } from "./ListaEndereco.vue?vue&type=template&id=2b7765d9&"
import script from "./ListaEndereco.vue?vue&type=script&lang=js&"
export * from "./ListaEndereco.vue?vue&type=script&lang=js&"
import style0 from "./ListaEndereco.vue?vue&type=style&index=0&id=2b7765d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports